import axios from 'axios'
const CancelToken = axios.CancelToken
let cancel
export function cancelRequest () {
  if (typeof cancel === 'function') {
    // 取消请求
    cancel()
  }
}

// 组成员api
import request from '@/util/request'

// 获取组
export function getStructure () {
  return request({
    url: `/group-s/acc/group/structure`,
    method: 'get',
    params: {
      language: stage.languageId
    }
  })
}
// 添加组
export function addGroup (data) {
  return request({
    url: `/group-s/acc/group`,
    method: 'post',
    data,
    cancelToken: new CancelToken(function executor (c) {
      cancel = c
    })
  })
}
// 删除组
export function deleteGroup (groupId) {
  return request({
    url: `/group-s/acc/group/${groupId}`,
    method: 'delete'
  })
}
// 更新组
export function updateGroup (groupId, data) {
  return request({
    url: `/group-s/acc/group/${groupId}`,
    method: 'post',
    data
  })
}

/// ///////////////////////////////////user-resource

// 获取组成员列表
export function getOrgUserList (data) {
  return request({
    url: `/user-s/acc/org/users`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor (c) {
      cancel = c
    })
  })
}

// 添加组成员
export function addOrgUser (data) {
  data.userInfo.system = stage.loc.customer
  return request({
    url: `/user-s/acc/org/user`,
    method: 'post',
    data,
    cancelToken: new CancelToken(function executor (c) {
      cancel = c
    })
  })
}

// 检查用户是否唯一
export function checkOrgUserIdentifier (data) {
  return request({
    url: `/user-s/acc/org/user/check`,
    method: 'post',
    data
  })
}

// 删除组成员
export function deleteOrgUser (userId) {
  return request({
    url: `/user-s/acc/org/user/${userId}`,
    method: 'delete'
  })
}
// 批量删除组成员
export function deleteBatch (data) {
  return request({
    url: `/user-s/acc/org/user/batch`,
    method: 'delete',
    data
  })
}

// 获取组成员
export function getOrgUser (orgId, userId) {
  return request({
    url: `/user-s/acc/org/${orgId}/user/${userId}`,
    method: 'get'
  })
}
// 更新组成员
export function updateOrgUser (userId, data) {
  return request({
    url: `/user-s/acc/org/user/${userId}`,
    method: 'post',
    data
  })
}
// 重置密码
export function resetPassword (userId, password) {
  return request({
    url: `/user-s/acc/user/${userId}/password/${password}`,
    method: 'post'
  })
}
// 批量重置密码
export function resetPasswordBatch (password, data) {
  return request({
    url: `/user-s/acc/user/batch/password/${password}`,
    method: 'post',
    data
  })
}
// 获取组成员
export function getOrgUserById (userId) {
  return request({
    url: `/user-s/acc/org/user/${userId}`,
    method: 'get',
    params:{language:stage.languageId}
  });
}
// 重置密码
export function resetPasswordOrg (userId, password) {
  return request({
    url: `/user-s/acc/org/user/${userId}/password/${password}`,
    method: 'post'
  })
}
// 批量重置密码
export function resetPasswordBatchOrg (password, data) {
  return request({
    url: `/user-s/acc/org/user/batch/password/${password}`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/manage/groupMember.js